define('GiftWrap.Shopping', [
    'SC.Configuration',
    'GiftWrap.Helper',
    'Cart.Item.Summary.View.GiftWrap',
    'Cart.Lines.View.GiftWrap',
    'ProductDetails.Component.GiftWrap',
    'ProductViews.Option.View.GiftWrap',
    'Transaction.Line.Views.Option.View.GiftWrap'
], function GiftWrapShopping(
    Configuration,
    GiftWrapHelper,
    CartItemSummaryViewGiftWrap,
    CartLinesViewGiftWrap,
    ProductDetailsComponentGiftWrap,
    ProductViewsOptionViewGiftWrap,
    TransactionLineViewsOptionViewGiftWrap
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            GiftWrapHelper.configure();
            CartItemSummaryViewGiftWrap.mountToApp(container);
            CartLinesViewGiftWrap.mountToApp(container);
            ProductViewsOptionViewGiftWrap.mountToApp(container);
            ProductDetailsComponentGiftWrap.mountToApp(container);
            TransactionLineViewsOptionViewGiftWrap.mountToApp(container);
        }
    };
});

